import * as React from "react"
import { cn } from "@/lib/utils"

interface UserMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  content: string
  avatarUrl?: string
}

const UserMessage = React.forwardRef<HTMLDivElement, UserMessageProps>(
  (
    {
      content,
      avatarUrl = "https://lh3.googleusercontent.com/aida-public/AB6AXuB8_GVbxRIQAAfouiQlUNFE8X454L8a6QhsO2t5-gp1CvR58mol_kpMqvdVPzMP21J1bh0Qyn5_OhJG3XWcOhw_4ArcMN2zrN06X_MkCg7Vyw0YOBq_OpjBzEZl7y1EDPsHojtc3bgzpe-2A8YnijWiJ5GIJXqXUbpVCzgVvjmlGR6M6Fuo46l3qfCmyDNPMjTiGEM4F0eHrvYYmDKblF1BSiE-DklSJPFZ5df1FiXl0q4eJekZ3CeCPv19XCbg64QnRJTm1oFsNAM",
      className,
      ...props
    },
    ref,
  ) => (
    <div ref={ref} className={cn("flex items-start justify-end gap-4", className)} {...props}>
      <div className="bg-blue-600 text-white rounded-lg rounded-br-none p-4 max-w-md">
        <p className="text-sm">{content}</p>
      </div>
      <img alt="User avatar" className="w-12 h-12 rounded-full flex-shrink-0" src={avatarUrl || "/placeholder.svg"} />
    </div>
  ),
)
UserMessage.displayName = "UserMessage"

export { UserMessage }
